import { CloseEyeIcon, eyeIcon } from "assets/icons";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext"
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { handleLoader, handleNotFound, setSelectedConnector } from "redux/counterSlice";
import { amazons3Login, asanaLogin, azureBlobLogin, confluenceLogin, dropboxLogin, freshserviceLogin, getConfigDataByID, gmailLogin, jiraLogin, loginConfig, salesforceLogin, saveAmazons3, saveAsana, saveConfluence, saveConnectors, saveDropbox, saveFreshservice, saveGmail, saveJira, saveSalesforce, saveServicenow, saveSharepoint, saveZendesk, servicenowLogin, sharepointLogin, zendeskLogin } from "services/pdfUploadService";
import CryptoJS from 'crypto-js';
import { Dropdown } from "primereact/dropdown";

const SharePointConnector = ({ setVisible, setSelectedCity, getData, id, onCancel, selectedcity, keys, loginKeys, handleChangeConnector, setSelectedCityAddUpdate, connectorsList, handleAddUpdateEdit }: any) => {
    const navigate = useNavigate();
    const params = useParams();
    const dispatch = useDispatch();
    const userName = localStorage.getItem("username")
    const selectedConnector = useSelector((state: any) => state.counter.selectedConnector);

    const { register, handleSubmit, formState: { errors }, clearErrors, watch, reset, setValue, trigger, getValues } = useForm();
    const [showPassword, setShowPassword] = useState(false);
    const [resetForm, setResetForm] = useState(false);
    const getFormErrorMessage = (name: string) => {
        return (
            errors[name] && (
                <small className="p-error">{errors[name]?.message?.toString()}</small>
            )
        )
    }

    const clearValidationErrorsOnChange = (fieldName: string) => {
        clearErrors(fieldName);
    };

    const watchedValue = watch('destination_path');

    const isPasswordRequired = params.id !== "login" ? true : false;
    const passwordValidation = (val: string) => {
        return isPasswordRequired
            ? {
                required: {
                    value: true,
                    message: `${val} is required`,
                },
            }
            : {}
    };

    const urlValidation = (fieldName: any) => {
        return {
            required: {
                value: true,
                message: `${fieldName} is required`,
            },
            pattern: {
                value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i,
                message: `Invalid URL format`
            }
        };
    };

    const decryptPassword = (encryptedPassword: string) => {
        // try {
        //     // Decrypt the password using AES decryption with the secret key
        //     const bytes = CryptoJS.AES.decrypt(encryptedPassword, secretKey);
        //     // Convert the bytes to a UTF-8 string
        //     const decryptedPassword = bytes.toString(CryptoJS.enc.Utf8);
        //     return decryptedPassword;
        // } catch (error: any) {
        //     console.error('Error decrypting password:', error.message);
        //     return null;
        // }

        try {
            const parsedKey = CryptoJS.enc.Utf8.parse(secretKey);

            // Decrypt using AES with ECB mode
            const decrypted = CryptoJS.AES.decrypt(encryptedPassword, parsedKey, {
                mode: CryptoJS.mode.ECB
            });
            // Convert decrypted data to UTF-8 string
            return decrypted.toString(CryptoJS.enc.Utf8);
        } catch (error) {
            console.error('Error decrypting data:', error);
            return '';
        }
    };

    const getDataById = async () => {
        // dispatch(handleLoader(true));
        try {
            const { result, error } = await getConfigDataByID(id);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            const decryptedResult = { ...result };
            Object.keys(decryptedResult).forEach((key) => {
                if (shouldEncrypt(key)) {
                    decryptedResult[key] = decryptPassword(decryptedResult[key]);
                }
            });
            // dispatch(handleLoader(false));
            reset(decryptedResult)
        } catch (error: any) {
            // dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    const secretKey = 'RONSFTPCONNECTOR';
    const iv = 'BBBBBBBBBBBBBBBB';
    // Function to encrypt the password
    const encryptPassword = (password: string) => {
        // Replace 'your-secret-key' with your own secret key
        // Encrypt the password using AES encryption with the secret key
        // const encryptedPassword = CryptoJS.AES.encrypt(password, secretKey).toString();
        // return encryptedPassword;
        const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(secretKey), {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.ECB
        });
        return encrypted.toString();
    };

    const shouldEncrypt = (key: any) => key.includes('secret') || key.includes('password') ||
        key.includes('client_id') || key.includes('client_secret') || key.includes('access_token')
        || key.includes('space_key') || key.includes('security_token') || key.includes('app_key') || key.includes('app_secret') || key.includes('aws_access_key_id');

    const onSubmit = async (data: any) => {
        setResetForm(false)
        data.connector_name = selectedcity?.name
        // data.password = encryptPassword(data.client_secret);
        keys.forEach((key: any) => {
            if (shouldEncrypt(key)) {
                data[key] = encryptPassword(data[key]);
            }
        });
        const temp: any = {}
        loginKeys.forEach((key: string) => {
            if (shouldEncrypt(key)) {
                temp[key] = encryptPassword(getValues(key));
            } else {
                temp[key] = getValues(key);
            }
        });
        const modifiedData = {
            ...data,
            connectors_keys: temp
        }
        if (id === "") {
            modifiedData.file_extension = [".pdf", ".docx", ".csv", ".txt", ".xlsx"]
            modifiedData.created_by = userName
            dispatch(handleLoader(true));
            try {
                const { result, error } = await saveConnectors(modifiedData);
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                setSelectedCity(selectedcity)
                getData(selectedConnector ? selectedConnector : selectedcity?.name);
                dispatch(setSelectedConnector(selectedcity?.name))
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
                setVisible(false);
            } catch (error: any) {
                dispatch(handleLoader(false));
                toast.error(error, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
            }
        } else if (id !== "") {
            delete modifiedData.created_by
            modifiedData.file_extension = [".pdf", ".docx", ".csv", ".txt", ".xlsx"]
            modifiedData.objectid = id;
            dispatch(handleLoader(true));
            modifiedData.updated_by = userName
            try {
                const { result, error } = await saveConnectors(modifiedData);
                handleAddUpdateEdit()
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                setSelectedCity(selectedcity);
                getData(selectedConnector ? selectedConnector : selectedcity?.name);
                dispatch(setSelectedConnector(selectedcity?.name))
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
                setVisible(false);
            } catch (error: any) {
                dispatch(handleLoader(false));
                toast.error(error, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
            }
        }
    }

    const clearValidationErrorsForOtherKeys = (selectedCityName: any) => {
        // Function to clear errors for keys other than the selected dropdown value
        const keysToClear = keys.filter((key: any) => key !== selectedCityName);
        keysToClear.forEach((key: any) => {
            setValue(key, ''); // Clear field value
            clearValidationErrorsOnChange(key); // Clear validation errors
        });
    };

    const handleTest = async () => {
        let isValid: boolean = false;
        // console.log("loginKeys", loginKeys)
        // "bucket_folder_path"
        switch (selectedcity?.name) {
            case 'amazons3':
                const awsData = loginKeys.filter((i: string) => i !== "bucket_folder_path")
                isValid = await trigger(awsData);
                break;
            case 'azureblob':
                const azureData = loginKeys.filter((i: string) => i !== "container_folder_path")
                isValid = await trigger(azureData);
                break;
            default:
                isValid = await trigger(loginKeys);
                break;
        }
        // if (selectedcity?.name === "amazons3") {
        //     const awsData = loginKeys.filter((i: string) => i !== "bucket_folder_path")
        //     isValid = await trigger(awsData);
        // } else {
        //     isValid = await trigger(loginKeys);
        // }
        if (isValid) {
            const temp: any = {};
            loginKeys.forEach((key: string) => {
                if (shouldEncrypt(key)) {
                    temp[key] = encryptPassword(getValues(key));
                } else {
                    temp[key] = getValues(key);
                }
            });
            setResetForm(true)
            dispatch(handleLoader(true));
            try {
                const { result, error } = await (selectedcity?.name === "sharepoint"
                    ? sharepointLogin(temp)
                    : selectedcity?.name === "confluence"
                        ? confluenceLogin(temp)
                        : selectedcity?.name === "amazons3"
                            ? amazons3Login(temp)
                            : selectedcity?.name === "dropbox"
                                ? dropboxLogin(temp)
                                : selectedcity?.name === "salesforce"
                                    ? salesforceLogin(temp)
                                    : selectedcity?.name === "jira"
                                        ? jiraLogin(temp)
                                        : selectedcity?.name === "servicenow"
                                            ? servicenowLogin(temp)
                                            : selectedcity?.name === "freshservice"
                                                ? freshserviceLogin(temp)
                                                : selectedcity?.name === "zendesk"
                                                    ? zendeskLogin(temp)
                                                    : selectedcity?.name === "gmail"
                                                        ? gmailLogin(temp)
                                                        : selectedcity?.name === "asana"
                                                            ? asanaLogin(temp)
                                                            : selectedcity?.name === "azureblob"
                                                                ? azureBlobLogin(temp)
                                                                : sharepointLogin(temp));
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                dispatch(handleLoader(false));
                setResetForm(false)
                toast.success(result.message, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
            } catch (error: any) {
                dispatch(handleLoader(false));
                setResetForm(false)
                toast.error(error, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
            }
        } else {
            const errorFields = Object.keys(errors);
            if (errorFields.length > 0) {
                const errorField = errorFields[0];
                const fieldElement = document.querySelector(`input[name=${errorField}]`);
                if (fieldElement) {
                    (fieldElement as HTMLElement)?.focus();
                } else {
                    console.warn(`Field with name ${errorField} not found`);
                }
            }
        }
    }

    // const onError = (errors: any) => {
    //     console.log('Form submission errors:', errors);
    // };

    useEffect(() => {
        if (resetForm === false && handleChangeConnector) {
            reset();
        }
    }, [handleChangeConnector, selectedcity?.name])

    useEffect(() => {
        dispatch(handleNotFound(false))
        if (id !== "" && selectedcity.name !== "SFTP") {
            getDataById();
        }
    }, [])

    const renderInput = (key: any) => {
        const label = key
            .split('_') // Split the key by underscores
            .map((word: any, index: any) => {
                if (word.toLowerCase() === 'url') return 'URL'; // Convert 'url' to 'URL'
                if (word.toLowerCase() === 'id') return 'ID';   // Convert 'id' to 'ID'
                if (word.toLowerCase() === 'key') return 'Key';   // Convert 'key' to 'Key'
                if (word.toLowerCase() === 'account') return 'Account';
                if (word.toLowerCase() === 'name') return 'Name';
                if (word.toLowerCase() === 'secret') return 'Secret';
                if (word.toLowerCase() === 'aws') return 'AWS';
                if (word.toLowerCase() === 'region') return 'Region ';
                if (word.toLowerCase() === 'access') return 'Access';   // Convert 'access' to 'Access'
                return index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word.toLowerCase();
            })
            .join(' '); // Join the words back into a label

        const placeholder = label;
        if (key.includes('secret') || key.includes('password')) {
            return (
                <div className='form-col mb-4' key={key}>
                    <label htmlFor={key} className="form-label">
                        {label} <span className="text-red-600">*</span>
                    </label>
                    <div className='d-flex position-relative'>
                        <InputText
                            // className="form-control"
                            type={showPassword ? "text" : "password"}
                            {...register(key, {
                                required: {
                                    value: true,
                                    message: `${label} is required`,
                                },
                            })}
                            placeholder={placeholder}
                            autoComplete="new-password"
                            onChange={() => clearValidationErrorsOnChange(key)}
                        />
                        <span className={`password-toggle2 c-pointer`} onClick={() => setShowPassword(!showPassword)}>
                            {!showPassword ? <img id='eyeicon' src={CloseEyeIcon} alt="eye-icon" /> :
                                <img id='close-eye-icon' src={eyeIcon} alt="close-eye-icon" />
                            }
                        </span>
                    </div>
                    {getFormErrorMessage(key)}
                </div>
            );
        }

        return (
            <div className='form-col mb-4' key={key}>
                <label htmlFor={key} className="form-label">
                    {label} <span className="text-red-600">*</span>
                </label>
                <div>
                    <InputText
                        type={key.includes('id') ? 'text' : 'text'}
                        // className="form-control"
                        // {...register(key, passwordValidation(label))}
                        // {...register(key, key.includes('url') ? urlValidation(label) : passwordValidation(label))}
                        {...register(key, passwordValidation(label))}
                        placeholder={placeholder}
                        onChange={() => clearValidationErrorsOnChange(key)}
                    />
                </div>
                {getFormErrorMessage(key)}
            </div>
        );
    };
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-sidebar-body">
                <div className='form-row'>
                    <div className='form-col'>
                        <label className="form-label">Date Source Type</label>
                        <Dropdown resetFilterOnHide={true} value={selectedcity} disabled={id !== "" ? true : false} onChange={(e) => { setSelectedCityAddUpdate(e.value); handleChangeConnector(e.value) }} options={connectorsList} optionLabel="code" />
                    </div>
                </div>
                <div className='form-row'>
                    {keys.map((key: any) => renderInput(key))}
                </div>
            </div>
            <div className='form-sidebar-footer'>
                <Button
                    type="button"
                    className='grey-outline-btn mr-3'
                    label='Cancel'
                    onClick={onCancel}
                >
                </Button>
                <Button className='grey-outline-btn mr-3' type="button" label='Test' onClick={handleTest}>
                </Button>
                <Button className='outline-active-btn' label='Save' type="submit">
                </Button>
            </div>
        </form>

    )
}

export default SharePointConnector